/** @flow */
import getURL from './getURL';


export default function () {
  return getURL('');
}
